// src/pages/RobotsTxt.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_URL;
const SITE_URL = process.env.REACT_APP_SITE_URL || window.location.origin;

export default function RobotsTxt() {
  const location = useLocation();

  useEffect(() => {
    const generateRobotsTxt = () => {
      const content = `# https://www.robotstxt.org/robotstxt.html
User-agent: *
Allow: /
Disallow: /admin/
Disallow: /superAdmin/
Disallow: /api/

# Sitemaps
Sitemap: ${SITE_URL}/sitemap.xml

# Crawl delay (optionnel)
Crawl-delay: 1

# Host (optionnel)
Host: ${SITE_URL}

# Pour les moteurs de recherche
User-agent: Googlebot
Allow: /
Crawl-delay: 0.5

User-agent: Bingbot
Allow: /
Crawl-delay: 1

User-agent: Yandex
Allow: /
Crawl-delay: 2
`;

      // Définir le type de contenu et servir le fichier
      const blob = new Blob([content], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      
      // Rediriger ou servir le fichier
      window.location.href = url;
    };

    generateRobotsTxt();
  }, [location]);

  return null;
}